export default angular.module('contartemx.preferencias.cobros', [
	'contartemx',
	'ui.router',
	'ui.bootstrap'
])
.controller('PrefCobrosCtrl', ['$scope', '$state', '$stateParams', 'apiCall', '$filter', 'mostrarNotificacion',
    function ($scope, $state, $stateParams, apiCall, $filter, mostrarNotificacion) {
        var regexClabe = /^(\d{18}|\*{14}\d{4})$/;
        $scope.loading = false;
        $scope.contribuyente = {

        };

        function actualizaValores(datos) {
            if (datos.Respuesta) {
                $scope.contribuyente.cobroActivo = datos.Respuesta.EstaActivo;
                $scope.contribuyente.clabe = datos.Respuesta.Clabe;
                $scope.contribuyente.requiereFactura = datos.Respuesta.RequiereFactura;
                $scope.contribuyente.giroComercial = datos.Respuesta.GiroComercial;
                $scope.contribuyente.banco = datos.Respuesta.BancoAsociado;
                $scope.contribuyente.aceptoTermCond = datos.Respuesta.AceptoTermCond;
                $scope.estadoCuenta = datos.Respuesta.EstadoCuenta;
                //$scope.contrato = datos.Respuesta.Contrato;
                $scope.identificacion = datos.Respuesta.Identificacion;
                $scope.girosComercial = datos.Respuesta.GirosComerciales;
                $scope.bancos = datos.Respuesta.Bancos;

                $scope.identificacionValida = datos.Respuesta.IdentificacionValida;
                $scope.estadoCuentaValido = datos.Respuesta.EstadoCuentaValido;

                if (!$scope.estadoCuenta || !$scope.identificacion || !$scope.identificacionValida || !$scope.estadoCuentaValido) {
                    mostrarNotificacion.info("No recibira los pagos a su cuenta de banco si no tiene un Estado de Cuenta o Identificacion configurado y aprobado");
                }

            }
        }

        function validarValores() {

            if (!$scope.contribuyente.aceptoTermCond) {
                mostrarNotificacion.error("Debe aceptar los terminos y condiciones");
                return false;
            }

            if (!angular.isObject($scope.contribuyente.giroComercial)
                || !angular.isString($scope.contribuyente.giroComercial.code)
                || $scope.contribuyente.giroComercial.code.trim().length == 0) {
                if (!angular.isString($scope.contribuyente.giroComercial)) {
                    mostrarNotificacion.error("Debe seleccionar un giro comercial");
                    return false;
                }           
            }  
            if (!angular.isNumber($scope.contribuyente.banco)) {
                mostrarNotificacion.error("Debe seleccionar un banco para asociar sus cobros.");
                return false;
            }
            if (!regexClabe.test($scope.contribuyente.clabe)) {
                mostrarNotificacion.error("Clabe invalida. Debe contener solo 18 digitos.");
                return false;
            }    
            return true;
        }

        var obtenerDatosParaCobro = function () {
            $scope.loading = true;
            apiCall.post('ObtenerPantallaCobros', {})
            .then(actualizaValores)
            .finally(function () {
                $scope.loading = false;
            });
        };

        obtenerDatosParaCobro();

        $scope.guardarInfoCobro = function () {
            if (validarValores()) {
                $scope.loading = true;
                apiCall.post('ActualizarDatosCobro', {
                    datosSc: {
                        Clabe: $scope.contribuyente.clabe,
                        RequiereFactura: $scope.contribuyente.requiereFactura,
                        GiroComercial: $scope.contribuyente.giroComercial ? $scope.contribuyente.giroComercial.code : '',
                        BancoAsociado: $scope.contribuyente.banco,
                        AceptoTermCond: $scope.contribuyente.aceptoTermCond,
                        EstaActivo: $scope.contribuyente.cobroActivo,
                    }                  
                })
                    .then(function (data) {
                        if (data.Respuesta) {
                            actualizaValores(data);
                        }
                        if (data.EsError) {
                            mostrarNotificacion.error(data.Mensaje  || "Error al actualizar los datos.");
                        } else {
                            mostrarNotificacion.info("Se han actualizado sus datos.");
                        }
                    }).finally(function () {
                        $scope.loading = false;
                    });
            }
        };

        $scope.formSuccessCB = function (data) {
            if (data.EsError || data.CodigoRespuesta == 500) {
                if (data.Mensaje !== null || data.Mensaje !== undefined) {
                    mostrarNotificacion.error(data.Mensaje);
                }
                else {
                    mostrarNotificacion.error("Error al intentar guardar los documentos.");
                }
            }
            else {
                mostrarNotificacion.info('Se guardaron satisfactoriamente los documentos.');
                $scope.guardarInfoCobro();
            }

        };

        $scope.formErrorCB = function (data) {
            if (data.error === 500) {
                $scope.guardarInfoCobro();
            } else {
                if (data.Mensaje) {
                    mostrarNotificacion.error(data.Mensaje);
                }
                else {
                    mostrarNotificacion.error("Error al intentar guardar los documentos.");
                }
            }      
        };

        function EliminarDocumento(documento) {
            return function () {
                if (angular.isString(documento) && documento.length > 0) {
                    apiCall.post("EliminarDocumentoCobro", { documento: documento })
                        .then(function (data) {
                            if (!data.EsError) {
                                var documentoEliminado = documento[0].toLowerCase() + documento.substr(1);
                                $scope[documentoEliminado] = null;
                            }                           
                        });
                }
            }
        }

        $scope.eliminarEstadoCuenta = EliminarDocumento("EstadoCuenta");
        //$scope.eliminarContrato = EliminarDocumento("Contrato");
        $scope.eliminarIdentificacion = EliminarDocumento("Identificacion");
        
}]);

